"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_state_tree_1 = require("mobx-state-tree");

var FillObj = mobx_state_tree_1.types.model({
  fill: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.string, ''),
  pattern: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.string, ''),
  color: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.string, '')
});
var FillModel = mobx_state_tree_1.types.union(FillObj, mobx_state_tree_1.types.string);
exports.FillModel = FillModel;
